module.exports = __webpack_public_path__ + "img/people-35-min.506c4874.png";